import request from '@/utils/request'


export function GetBranchDeliveryPlace(branchId) {
    return request({
        url: '/DeliveryPlace/GetBranchDeliveryPlace',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function SavePlace(id, branchId, name, address, active) {
    return request({
        url: '/DeliveryPlace/Save',
        method: 'post',
        data: {
            Id: id,
            BranchId: parseInt(branchId),

            Active: active,
            Address: address,
            Name: name
        }

    })
}

export function DeletePlace(id) {
    return request({
        url: '/DeliveryPlace/Delete',
        method: 'post',
        data: {
            Id: id,

        }

    })
}